module.exports = __webpack_public_path__ + "img/qrcode.6ed0b118.png";